import {useState} from 'react'

import {useMapMeasurementTypeMutation} from '../../../hooks/mutations/useMapMeasurementTypeMutation'
import type {LimsMeasurementType} from '../../../types/LimsMeasurementType'
import {UnsavedRow} from '../UnsavedMappingRow'

interface UseManageUnsavedMappingRowsProps {
  plantCode: string
  unmappedLimsMeasurementTypes: LimsMeasurementType[]
  globalTypeId: number
}

export const useManageUnsavedMappingRows = ({
  plantCode,
  unmappedLimsMeasurementTypes,
  globalTypeId
}: UseManageUnsavedMappingRowsProps) => {
  const [unsavedRows, setUnsavedRows] = useState<UnsavedRow[]>([])

  const {mutate: mapMeasurementType, isPending: isUnsavedRowBeingMapped} =
    useMapMeasurementTypeMutation()

  const handleAddMappingRow = () => {
    if (unmappedLimsMeasurementTypes.length === 0) return
    setUnsavedRows((prev) => [...prev, {tempId: `new-${Date.now()}`}])
  }

  const handleDeleteUnsavedMappingRow = (tempId: string) => {
    setUnsavedRows((prev) => prev.filter((row) => row.tempId !== tempId))
  }

  const handleSelectTypeInUnsavedMappingRow = (tempId: string, limsTypeId: number) => {
    mapMeasurementType(
      {
        plantCode,
        globalMeasurementTypeId: globalTypeId,
        limsMeasurementTypeId: limsTypeId
      },
      {
        onSettled: () => {
          setUnsavedRows((prev) => prev.filter((row) => row.tempId !== tempId))
        }
      }
    )
  }

  return {
    unsavedRows,
    isUnsavedRowBeingMapped,
    handleAddMappingRow,
    handleDeleteUnsavedMappingRow,
    handleSelectTypeInUnsavedMappingRow
  }
}
